import { getAdditionalAndIncludedCoreSalesServiceSeatsTotalInProductConfiguration, getCheckoutProductConfigurations, getCheckoutProductConfigurationsForSeats, getConfigsWithSuiteIfPossible, getConfigurationsWithPBORequiredOnboarding, getCurrentAdditionalAndIncludedCoreSeatTotal, getHighestProductLevelInProductConfigurations, getIncludedCoreSeatsQuantity, getIncludedSeatQuantityForProductConfiguration, getInitialCoreSeatsTotalForProductConfiguration, getInitialProductConfigurationsWithSalesServiceSeats, getNonRecurringProductConfigurations, getOfferProductConfigurations, getProductConfigurationForSeats, getProductConfigurationWithFreeCoreSeatIfPossible, getProductLevelForCoreSeats, getProductLevelInConfigs, getProductsAndPacksForQueryParams, getProductVersionConfigsWithUnits, getSelectedAdditionalAndIncludedCoreSeatTotal, getSortedProductConfigurations, getSuiteProductConfigurations } from 'pricing-pages-lib/utils/productConfigUtils';
import { productForSkuIdSelector, skuSelector, productSelector, skuIdHasBundledProductsSelector } from './ProductsSelectors';
import { createSelectorFromUtil } from 'pricing-pages-lib/utils/selectorUtils';
import { QUANTITY_PACK } from 'self-service-api/constants/SkuTypes';
import { transformState } from './SelectorUtils';
import { getBundledProductLinesForSkuId } from 'pricing-pages-lib/utils/productsUtils';
export const configsWithSuiteIfPossibleSelector = createSelectorFromUtil(getConfigsWithSuiteIfPossible, transformState);
export const checkoutProductConfigurationsSelector = createSelectorFromUtil(getCheckoutProductConfigurations, transformState);
export const suiteProductConfigurationsSelector = createSelectorFromUtil(getSuiteProductConfigurations, transformState);
export const productLevelInConfigsSelector = createSelectorFromUtil(getProductLevelInConfigs, transformState);
export const configurationsWithPBORequiredOnboardingSelector = createSelectorFromUtil(getConfigurationsWithPBORequiredOnboarding, transformState);
export const offerProductConfigurationsSelector = createSelectorFromUtil(getOfferProductConfigurations, transformState);
export const nonRecurringProductConfigurationsSelector = createSelectorFromUtil(getNonRecurringProductConfigurations, transformState);
export const getFirstHubSkuIdFromProductConfigurations = (state, {
  productConfigurations
}) => {
  const foundProductConfig = productConfigurations.find(({
    skuId
  }) => {
    const {
      productLine,
      productLevel
    } = productForSkuIdSelector(state, {
      skuId
    });
    const isBundledProduct = skuIdHasBundledProductsSelector(state, {
      skuId
    });
    return productLine && productLevel || isBundledProduct;
  });
  if (!foundProductConfig) return 0;
  const foundSku = skuSelector(state, {
    skuId: foundProductConfig.skuId
  });
  let foundSkuId;
  const {
    skuType
  } = foundSku;
  if (skuType === QUANTITY_PACK) foundSkuId = foundSku.productVersionSkuId;else foundSkuId = foundSku.skuId;
  return foundSkuId;
};
export const productVersionConfigsWithUnitsSelector = createSelectorFromUtil(getProductVersionConfigsWithUnits, transformState);
export const bundledProductLinesForSkuIdSelector = createSelectorFromUtil(getBundledProductLinesForSkuId, transformState);
export const productVersionFromConfigsSelector = (state, {
  productConfigurations,
  productLine
}) => {
  for (let i = 0; i < productConfigurations.length; i++) {
    const {
      productId,
      productVersionSkuId,
      skuId
    } = skuSelector(state, {
      skuId: productConfigurations[i].skuId
    });
    const {
      productLine: tempProductLine
    } = productSelector(state, {
      productId
    });
    const bundledProductLines = bundledProductLinesForSkuIdSelector(state, {
      skuId
    });

    if (tempProductLine === productLine || bundledProductLines.includes(productLine)) {
      // If the sku we selected is a quantity pack, it will have this field
      if (productVersionSkuId) {
        return skuSelector(state, {
          skuId: productVersionSkuId
        });
      }

      return skuSelector(state, {
        skuId
      });
    }
  }

  return null;
};
export const highestProductLevelInProductConfigurations = createSelectorFromUtil(getHighestProductLevelInProductConfigurations, transformState);
export const productsAndPacksForQueryParamsSelector = createSelectorFromUtil(getProductsAndPacksForQueryParams, transformState);
export const productLevelForCoreSeatsSelector = createSelectorFromUtil(getProductLevelForCoreSeats, transformState);
export const includedCoreSeatsQuantitySelector = createSelectorFromUtil(getIncludedCoreSeatsQuantity, transformState);
export const productConfigurationWithFreeCoreSeatIfPossibleSelector = createSelectorFromUtil(getProductConfigurationWithFreeCoreSeatIfPossible, transformState);
export const productConfigurationForSeatsSelector = createSelectorFromUtil(getProductConfigurationForSeats, transformState);
export const sortedProductConfigurationsSelector = createSelectorFromUtil(getSortedProductConfigurations, transformState);
export const checkoutProductConfigurationsForSeatsSelector = createSelectorFromUtil(getCheckoutProductConfigurationsForSeats, transformState);
export const initialCoreSeatsTotalForProductConfigurationSelector = createSelectorFromUtil(getInitialCoreSeatsTotalForProductConfiguration, transformState);
export const initialProductConfigurationsWithSalesServiceSeatsSelector = createSelectorFromUtil(getInitialProductConfigurationsWithSalesServiceSeats, transformState);
export const additionalAndIncludedCoreSalesServiceSeatsTotalInProductConfigurationSelector = createSelectorFromUtil(getAdditionalAndIncludedCoreSalesServiceSeatsTotalInProductConfiguration, transformState);
export const currentAdditionalAndIncludedCoreSeatTotalSelector = createSelectorFromUtil(getCurrentAdditionalAndIncludedCoreSeatTotal, transformState);
export const selectedAdditionalAndIncludedCoreSeatTotalSelector = createSelectorFromUtil(getSelectedAdditionalAndIncludedCoreSeatTotal, transformState);
export const includedSeatQuantityForProductConfigurationSelector = createSelectorFromUtil(getIncludedSeatQuantityForProductConfiguration, transformState);